import { MoonLoader } from 'react-spinners';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { columnShape, rowShape } from 'helpers/shared_types';
import Cell from './cell';
import Header from './header';

const ViewContent = ({
  columns,
  data,
  fetching,
  onDatePick,
  onDelete,
  onLink,
  onSelect,
  onSelectedOptionsChange,
  onSingleDatePick,
  onStatusUpdate,
  onTextUpdate,
  selectedOptions,
}) => {
  const onChange = (accessor, options) => {
    selectedOptions[accessor] = options
      .filter((o) => o.selected)
      .map((o) => `${o.value}`); //respect null
    onSelectedOptionsChange(selectedOptions);
  };
  if (fetching) {
    return (
      <section className="content-list table-view">
        <ol className="th-list">
          <li className="th-list-row header">
            {columns.map((header, index) => (
              <Header
                key={index}
                data={header}
                fetching
                onChange={(options) => onChange(header.accessor, options)}
              />
            ))}
          </li>
        </ol>

        <div className="flex justify-center mt40">
          <MoonLoader color="#455d7a" size={60} />
        </div>
      </section>
    );
  }

  return (
    <section className="content-list table-view">
      <ol className="th-list">
        <li className="th-list-row header">
          {columns.map((header, index) => (
            <Header
              key={index}
              data={header}
              onChange={(options) => onChange(header.accessor, options)}
            />
          ))}
        </li>

        {data?.map((row) => (
          <li
            key={row.id}
            data-cy={row.id}
            className={classnames('th-list-row th-members-list-item', {
              'th-highlighted-orange': row.isHighlighted === 'orange',
              'th-highlighted-red': row.isHighlighted === 'red',
            })}
          >
            {columns.map((col, i) => (
              <Cell
                key={i}
                column={col}
                data={row}
                onSelect={(accessor, value) => onSelect(accessor, value, row)}
                onTextUpdate={(value) => onTextUpdate(value, row, col)}
                onDatePick={(first, second) => onDatePick(first, second, row)}
                onSingleDatePick={(date) => onSingleDatePick(date, row)}
                onStatusUpdate={() => onStatusUpdate(row, col)}
                onDelete={() => onDelete(row)}
                onLink={() => onLink(row)}
              />
            ))}
          </li>
        ))}
      </ol>
    </section>
  );
};

ViewContent.propTypes = {
  columns: PropTypes.arrayOf(columnShape),
  data: PropTypes.arrayOf(rowShape),
  fetching: PropTypes.bool,
  onDatePick: PropTypes.func,
  onDelete: PropTypes.func,
  onSelect: PropTypes.func,
  onSelectedOptionsChange: PropTypes.func,
  onSingleDatePick: PropTypes.func,
  onStatusUpdate: PropTypes.func,
  onTextUpdate: PropTypes.func,
  selectedOptions: PropTypes.shape({
    doctor: PropTypes.arrayOf(PropTypes.string),
    nextAction: PropTypes.arrayOf(PropTypes.string),
    manualPaymentStatus: PropTypes.arrayOf(PropTypes.string),
    recordingStatus: PropTypes.arrayOf(PropTypes.string),
    status: PropTypes.arrayOf(PropTypes.string),
    technician: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default ViewContent;
